var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8530571HeartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.727,
    height: 12.889,
    viewBox: "0 0 14.727 12.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8530571_heart_icon",
    "data-name": "8530571_heart_icon",
    d: "M13.185,32.908a4.333,4.333,0,0,0-5.822.431,4.33,4.33,0,0,0-5.822-.431,4.352,4.352,0,0,0-.3,6.362l5.045,5.14a1.511,1.511,0,0,0,2.163,0l5.045-5.14A4.355,4.355,0,0,0,13.185,32.908ZM12.506,38.3l-5.045,5.14a.118.118,0,0,1-.2,0L2.22,38.3a2.966,2.966,0,0,1,.21-4.335,2.916,2.916,0,0,1,3.926.3L7.363,35.3,8.37,34.268a2.914,2.914,0,0,1,3.926-.3A2.979,2.979,0,0,1,12.506,38.3Z",
    transform: "translate(0 -31.978)",
    fill: "#6d4eec"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8530571HeartIcon);
export default __webpack_public_path__ + "static/media/8530571_heart_icon.f3b6ed05eca26b59bf03547c057f6a54.svg";
export { ForwardRef as ReactComponent };